module.exports = __webpack_public_path__ + "img/page10.d6d32ba1.png";